/**
 * @author Matthew Rogers
 */
var AttachmentController = (function () {
    function AttachmentController($state, $scope, socket, topic, env, settings, notify, $attrs) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.$attrs = $attrs;
        this.lockEnabled = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.showAttachment = false;
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.fileList = this.topic.topic.files;
        ;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.socket.forward("attachments.mysa.names", this.$scope);
        this.$scope.$on('socket:attachments.mysa.names', function (event, data) {
            if (_this.isMysaV3()) {
                if (data.type === 'SUCCESS') {
                    if (_this.$attrs.incentive === data.incentive) {
                        _this.fileList = data.files;
                    }
                    return;
                }
                else {
                    console.error(data.message);
                    return _this.notify.error(data.message);
                }
            }
        });
        this.socket.forward("attachments.mysa.comments.save", this.$scope);
        this.$scope.$on('socket:attachments.mysa.comments.save', function (event, data) {
            if (_this.isMysaV3()) {
                //this.topic[this.comp].locked = false;
                _this.topic.updatePartialSocketStatus(_this.updateArray, '');
                if (data.type === 'SUCCESS') {
                    console.log(data.message);
                    return _this.notify.success(data.message);
                }
                else {
                    console.error(data.message);
                    return _this.notify.error(data.message);
                }
            }
        });
    }
    AttachmentController.prototype.showHide = function () {
        this.showAttachment = this.showAttachment ? false : true;
    };
    AttachmentController.prototype.decode = function (file) {
        return decodeURIComponent(file); //Probably not necessary anymore since names are not being stored encoded
    };
    // Prepares the files for file upload
    AttachmentController.prototype.uploadFiles = function (files) {
        this.fileNames = [];
        var fileContent = files;
        // If some files submitted perform the update
        if (fileContent.length > 0) {
            // check that file names are unique
            for (var _i = 0, fileContent_1 = fileContent; _i < fileContent_1.length; _i++) {
                var file = fileContent_1[_i];
                for (var _a = 0, _b = this.topic.topic.files; _a < _b.length; _a++) {
                    var existingFile = _b[_a];
                    if (file.name === existingFile.name) {
                        this.notify.error("File attachment with name '" + file.name + "' already exists");
                        this.edit.editMode = this.topic.cancelEdit(this.comp);
                        return;
                    }
                }
            }
            var i = 0;
            for (var _c = 0, fileContent_2 = fileContent; _c < fileContent_2.length; _c++) {
                var file = fileContent_2[_c];
                this.fileNames[i] = { name: file.name, type: file.type, comment: '' };
                i++;
            }
            this.fileUploaded = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'uploadFile',
                    script: 'config/config',
                    data: { files: this.fileNames, id: this.topic.topic._id, type: this.section },
                    files: this.sources,
                    bID: this.topic.topicBrowserID,
                    token: this.env.user.token
                }
            });
        }
        this.edit.editMode = this.topic.cancelEdit(this.comp);
    };
    AttachmentController.prototype.downloadAttachment = function (file) {
        var name = file.pureName ? file.pureName : file.name;
        var type = file.type;
        var version = file.version;
        if (['mysa'].includes(type)) {
            this.downloadMysaAttachment(name, version);
        }
        else if (['si', 'ei', 'ai'].includes(type)) {
            this.downloadMysaAttachment(name, version, type);
        }
        else {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: {
                        id: this.topic.topic._id,
                        name: name
                    },
                    function: 'downloadAttachment',
                    script: '/detail/eligibility/eligibility',
                    token: this.env.user.token
                }
            });
        }
    };
    AttachmentController.prototype.downloadMysaAttachment = function (name, version, type) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    name: name,
                    opportunityId: this.topic.topic._id,
                    version: version,
                    type: type
                },
                function: 'downloadAttachment',
                script: '/mysa-attachments/maGate',
                token: this.env.user.token
            }
        });
    };
    AttachmentController.prototype.showUserData = function (file, visible) {
        file.visible = visible;
    };
    AttachmentController.prototype.getFileList = function () {
        var _this = this;
        //vm.fileList| filter: { type: vm.section }
        return this.fileList.filter(function (fileItem) {
            return _this.section === fileItem.type ||
                (_this.section === 'sampling_SSA' && fileItem.type === 'sampling') ||
                _this.section === 'mysa';
        }); // filtered by type on server for this case
    };
    AttachmentController.prototype.$onInit = function () {
        //The display name, ie: Validation, Eligibility, Find CMR etc
        if (this.$attrs.title) {
            this.title = this.$attrs.title;
        }
        else {
            this.title = this.topic.tabs.short;
        }
        if (this.$attrs.section) {
            this.section = this.$attrs.section;
            this.incentive = this.$attrs.incentive;
        }
        else {
            this.section = this.topic.tabs.short;
        }
        this.comp = "files$" + this.section;
        this.updateArray = [("" + this.comp)];
        this.edit = this.topic.getEditComponent(this.comp);
        //treat mysa version 3 in specific way - file list is located in a separate document
        if (this.isMysaV3()) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    bID: this.topic.topicBrowserID,
                    data: {
                        opportunityId: this.topic.topic._id,
                        types: this.getMysaAttachmentTypes(),
                        incentive: this.$attrs.incentive
                    },
                    function: 'getAttachmentNames',
                    script: 'mysa-attachments/maGate',
                    token: this.env.user.token,
                    email: this.env.user.email
                }
            });
        }
    };
    AttachmentController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
                if (this.isMysaV3()) {
                    // save file comments to the specific file in attachments db for mysa for v3
                    var commentsData_1 = {
                        opportunityId: this.topic.topic._id,
                        type: this.comp,
                        fileComments: []
                    };
                    angular.forEach(this.fileList, function (file) {
                        commentsData_1.fileComments.push({ name: file.pureName, version: file.version, comment: file.comment });
                    });
                    this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            bID: this.topic.topicBrowserID,
                            data: commentsData_1,
                            function: 'saveAttachmentComments',
                            script: 'mysa-attachments/maGate',
                            token: this.env.user.token
                        }
                    });
                }
                else {
                    // standard behaviour
                    this.topic.sendForUpdateFiles(this.comp, false);
                }
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPartFiles(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    AttachmentController.prototype.commentChange = function (fileName) {
        angular.forEach(this.topic.temp.files, function (file) {
            if (file.name === fileName) {
                file.modified = true;
            }
        });
    };
    AttachmentController.prototype.isMysaV3 = function () {
        return ['mysa'].includes(this.$attrs.section) && this.topic.checksData && this.topic.checksData.uiVersion >= this.OPP_VERSION_3;
    };
    AttachmentController.prototype.getMysaAttachmentTypes = function () {
        var types; // mysa attachment type
        if (this.topic.topic.version >= this.OPP_VERSION_4) {
            if (this.$attrs.incentive) {
                if (this.$attrs.incentive === 'Solution') {
                    types = ['ei', 'ai'];
                }
                else if (this.$attrs.incentive === 'SSA') {
                    types = ['si', 'ai'];
                }
                else {
                    types = ['ei', 'si', 'ai'];
                }
            }
        }
        if (this.topic.topic.version === this.OPP_VERSION_4) {
            if (!types) {
                types = [];
            }
            types.push('mysa');
        }
        return types;
    };
    AttachmentController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify', '$attrs'];
    return AttachmentController;
}());
var AttachmentComponent = (function () {
    function AttachmentComponent() {
        this.templateUrl = 'attachment.html';
        this.controllerAs = 'vm';
        this.controller = AttachmentController;
    }
    return AttachmentComponent;
}());
angular
    .module('application')
    .component('attachmentSection', new AttachmentComponent());

//# sourceMappingURL=attachment.component.js.map
